import axiosInstance from "./axiosConfig";
import { handleApiError } from "./errorHandler";

export const guidance_table_data_api = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/guidance_list`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'guidance_table_data_api');
    }
};

export const guidance_delete = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/delete_cuzguidance`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'guidance_delete');
    }
};
